module.exports = {
  //交互反馈
  request: {
    201: "参数错误",
    202: "账号不能为空",
    203: "密码不能为空",
    204: "账号错误",
    205: "密码错误",
    206: "信息错误，请联系管理员",
    207: "币种不存在",
    208: "购买数量超出范围",
    300: "请求失败",
    209: "密码不一致",
    236: "账号已存在",
    211: "原始密码错误",
    212: "新密码不能为空",
    213: "名称不能为空",
    214: "姓氏不能为空",
    215: "请选择证件类型",
    216: "证件号码不能为空",
    217: "正面证件照不能为空",
    218: "反面证件照不能为空",
    219: "请选择国籍",
    220: "手持证件照不能为空",
    221: "手持协议书不能为空",
    222: "余额不足",
    223: "订单错误，请联系管理员",
    230: "选择的币种不可以相同",
    234: "请使用正确的邮箱",
    235: "验证码不正确",
    237: "当前账号暂未注册，请注册",
    231: "选择的币种不能为空"
  },

  //国家
  country: {
    Usa: "美国",
    China: "中国",
    korea: "韩国",
    Japan: "日本",
    HongKong: "中国香港",
    Taiwan: "中国台湾",
    Russia: "俄罗斯",
    France: "法国",
    britain: "英国",
    Germany: "德国",
    Brazil: "巴西",
    Italy: "意大利",
    Canada: "加拿大",
    Spain: "西班牙",
    Malaysia: "马来西亚",
    Singapore: "新加坡",
    Indonesia: "印度尼西亚",
    Philippines: "菲律宾",
    Vietnam: "越南",
    India: "印度",
    Bhutan: "不丹",
    Finland: "芬兰",
    Sweden: "瑞典",
    Norway: "挪威",
    Iceland: "冰岛",
    Denmark: "丹麦",
    zimbabwe: "津巴布韦",
    Netherlands: "荷兰",
    Thailand: "泰国",
  },

  //证件
  certificates: {
    passport: "护照",
    ID: "身份证",
    driverLicense: "驾驶证"
  },

  //通用
  currency: {
    loading: "加载中",
    determine: "确定",
    cancel: "取消",
    tips: "提示",
    psdRule: "密码必须是字母+数字组合",
    psdLength: "密码长度不得少于6位",
    loginPsdLength: "密码长度不得少于8位",
    actionSuccess: "操作成功",
    success: "成功",
    fail: "失败",
    passed: "审核中",
    return: "返回"
  },

  // 登陆页
  login: {
    welComeToLogin: '登录',
    username: "账号",
    password: "密码",
    submit: "提交",
    noAccount: "没有账号",
    register: "注册",
    forgetPassword: "忘记密码",
    loginSuccess: "登录成功",
    logoutSuccess: "退出成功",
    enterAccount: "请输入账号",
    enterPsw: "请输入密码",
    rememberPassword: "记住密码"
  },

  //注册页
  register: {
    registeredAccount: "注册账号",
    mailboxRegistration: "邮箱注册",
    mailbox: "邮箱",
    setPassword: "设置密码",
    confirmPassword: "确认密码",
    readAgree: "我已阅读并同意",
    userAgreement: "用户协议",
    and: "和",
    privacyClause: "隐私条款",
    existingAccount: "已有账号",
    signIn: '登录',
    registerSuccess: "注册成功",
    pleaseRead: "请先阅读用户协议和隐私条款",
    inviteCode: "邀请码",
    verificationCode: "验证码"
  },

  //忘记密码
  forgetPassword: {
    code: "验证码",
    forgetPassword: "忘记密码",
    sendCode: "发送验证码"
  },

  //顶部导航栏
  nav: {
    home: "首页",
    quotation: "行情",
    transaction: "交易",
    notice: "公告",
    securityCenter: "安全中心",
    assets: "我的资产",
    recharge: "充值",
    withDrawal: "提现",
    fundTransfer: "资金划转",
    orderCenter: "订单中心",
    exchange: "兑换",
    logOut: "退出登录",
    downloadApp: "扫码下载APP",
    moreClient: "更多客户端",
    chinese: "中文",
    traditionalChinese: "繁体",
    english: "英语",
    korean: "韩文",
    japanese: "日语",
    continueToExit: "是否继续退出"
  },

  //首页
  home: {
    name: "名称",
    price: '价格',
    amount: "今日涨跌",
    title: "交易，随时随地",
    desc: "多终端完美兼容，随时满足各种场景的交易需求",
    text1: "随时查看实时行情",
    text2: "轻松买卖BTC,ETH,XRP,OKB和其他数字资产",
    text3: "获取您关注的加密货币价格变化预警",
    text4: "查看比特币现货、期货、期权价格",
    text5: "比较各交易所加密货币价格",
    title1: "全球领先",
    title2: "数字资产服务平台",
    desc2: "安全 · 稳定 · 可信",
    createAccount: "创建账户",
    text6: "开启您的数字货币之旅"
  },

  //行情
  quotes: {
    title: "今日行情"
  },

  //安全中心
  securityCenter: {
    identityAuthentication: "身份认证",
    desc: "完成个人认证有助于保护账户安全，提高提现额度及交易权限",
    go: "前往",
    loginPassword: "登录密码",
    desc1: "用于保护账户安全",
    edit: "修改",
    fundPassword: '资金密码',
    desc2: "用于保护资金安全",
    setUp: "设置",
    changePassword: "修改密码",
    changePasswordAlert: "修改登录密码后24小时内禁止提币和OTC划转",
    originalPassword: "原密码",
    newPassword: "新密码",
    confirmPassword: "确认新密码",
    setFundPassword: "设置资金密码",
    resetFundPassword: "重置资金密码",
    confirmFundPassword: "确认资金密码",
    setSuccessfully: "设置成功"
  },

  //身份认证
  personalAuthentication: {
    identityAuthentication: "身份认证",
    personalIdentityAuthentication: "个人身份认证",
    know: "悉知",
    primaryCertification: "初级认证",
    desc: "增加提币额度，24小时限额200BTC",
    advancedCertification: "高级认证",
    submitApproval: "提交",
    agreementDownload: '反洗钱协议下载',
    handCertificates: "请上传手持证件照片",
    handCertificates2: "请上传手持证件照片反洗钱协议照片",
    national: "国籍",
    surname: "姓",
    realname: "名",
    papersType: "证件类型",
    papers: "证件号",
    papersPositive: "请上传正面照",
    papersReverse: "请上传反面照",
    pleaseEnter: "请输入",
    title: "为什么我必须进行身份认证",
    content: "实名认证是为了遵守当前的金融法规或相关政策。实名认证更有助于保护您的账户安全，避免部分欺诈手段。我们将对您的信息进行严格保密",
    title2: "暂时不支持哪些国家",
    content2: "实名认证是为了遵守当前的金融法规或相关政策。实名认证更有助于保护您的账户安全，避免部分欺诈手段。我们将对您的信息进行严格保密",
    verificationCertification: "请先进行高级认证",
    authentication: "立即认证",
    PrimaryAuditPassed: "初级审核通过",
    level0: "已注册",
    level1: "初级审核中",
    level2: "初级审核未通过",
    level3: "初级审核通过",
    level4: "高级审核中",
    level5: "高级审核未通过",
    level6: "高级审核通过",
  },

  //交易
  transaction: {
    pleaseSelect: "请选择",
    price: "价格",
    requiredMargin: "所需保证金",
    closingFee: "平仓手续费",
    stopSurplus: "止盈",
    default: "默认",
    stopLoss: "止损",
    purchase: "买入",
    currentPosition: "目前持仓",
    historicalContract: "历史合约",
    order: "订单号",
    creationTime: "创建时间",
    transactionType: "交易类型",
    buyUp: "买涨",
    buyFall: "买跌",
    num: "数量",
    bond: "保证金",
    serviceCharge: "手续费",
    ClosingProfitLoss: "平仓盈亏",
    netProfitLoss: "净盈亏",
    orderStatus: "订单状态",
    operation: "操作",
    compulsoryLiquidation: "强制平仓",
    forceClosing: "是否确定强制平仓?",
    pleaseLogin: "您暂未登录，请先登录！",
    buyCurrentPrice: "当前币种价格为0",
    charged: "平仓时间",
    buildingTime: "建仓时间",
    buildingPrice: "建仓价格",
    currencyPriceNew: "平仓价格",
    heightPrice: "24h最高值",
    lowPrice: "24h最低值",
    latestTransaction: "最新成交",
    FloatingPL: "浮动盈亏",
    storageFee: "仓储费",
    status1: "自动止盈平仓",
    status2: "自动止损平仓",
    status3: "手动止盈平仓",
    status4: "手动止损平仓",
    status5: "运行中",
  },

  assets: {
    accountOverview: "账户总览",
    currencyAccount: "币币账户",
    contractAccount: "合约账户",
    transfer: "划转",
    withdrawMoney: "提币",
    chargeMoney: "充币",
    Cryptocurrency: "加密货币",
    currency: "货币",
    available: "可用",
    valuation: "估值",
    operation: "操作",
    chargingCurrency: "选择充币币种",
    currencyType: "币种",
    alert1: "最小充值金额",
    alert2: "小于最小金额的充值将不会上账且无法退回",
    ChargingInfo: "确认币种信息",
    ChargingNetwork: "充币网络",
    rule2: "您充值至上述地址后，需要整个网络节点的确认，12次网络确认后到账，12次网络确认后可提币。",
    rule3_btc: "最小充值金额：0.01BTC，小于最小金额的充值将不会上账且无法退回。",
    rule3_usdt: "最小充值金额：300USDT，小于最小金额的充值将不会上账且无法退回。",
    rule3_eth: "最小充值金额：0.15ETH，小于最小金额的充值将不会上账且无法退回。",
    rule4: "您的充值地址不会经常改变，可以重复充值；如有变更，我们会尽量通过网站公告或邮件通知您。",
    rule5: "请务必确认电脑及浏览器安全，防止信息被篡改或泄露",
    ChargingRecord: "充币记录",
    time: "时间",
    netWorkAddress: "网络地址",
    selectWithdrawalCurrency: "选择提币币种",
    ol1: "为保障资金安全，当您账户安全策略变更，密码修改，我们会对提币进行人工审核，请耐心等待工作人员邮件联系。",
    ol2: "请务必确认电脑及浏览器安全，防止信息被篡改或泄露",
    withdrawalInfo: "填写提币信息",
    withdrawAddress: "提币地址",
    withdrawalNetwork: "提币网络",
    withdrawalNum: "提币数量",
    minWithdrawalNum: "最小提币数量",
    actualArrival: "实际到账",
    notLessThan: "不可小于",
    viewAll: "查看全部币种",
    withdrawalRecord: "提币记录",
    transferCurrency: "请选择划转币种",
    transferNum: "划转数量",
    from: "从",
    to: "到",
    transferRecord: "划转记录",
    exceedBalance: "不可大于可用数量",
    use: "使用",
    convertInto: "兑换成",
    exchangeRate: "汇率",
    exChangeAlert: "费率：2% | 旷工费自付",
    exchangeInstructions: "兑换须知",
    desc1: "请注意，资金兑换受市场深度和行情影响，价格将会随时变化，请以订单确认后的最终金额为准",
    desc2: "根据风控系统要求，资金兑换如果触发第三方风控，兑换用户需要配合审核员完善相关审核，如果无法完善审核，订单会在至少一个月（30天）为您做退币处理",
    desc3: "请您确保资金兑换属于个人行为，并确认不使用数字货币参与任何传销，非法集资，诈骗等违法活动，请警惕一切许诺高额利息汇报的非法项目，谨防上当受骗，避免造成不必要的损失",
    exchangeRecord: "兑换记录",
    useCurrency: "使用币",
    exchangeCurrency: "兑换币",
    AbsenteeismFee: "旷工费",
    exchangeQuantity: "兑换数量",
    paymentPassword: "请输入支付密码",
    currencyNoSame: "币种不能相同"
  },

  // 二期
  iteration: {
    contractMarket: "合约市场",
    quotationDesc: "总览数字货币行情",
    accountOverview: "账户总览",
    accountOverviewDesc: "帐号内资金情况总览",
    all: "全部",
    userCenter: "个人中心",
    viewInfo: "查看个人资料信息",
    setPsdDesc: "设置强度较高的密码有利于账户安全。",
    homeTitle: "全球第一的潜力币交易所",
    homeDesc: "全球领先的上币团队，独特潜力的交易所",
    homeTitle2: "全球最大的社交化交易平台",
    homeDesc2: "全球领先的上币团队，独特潜力的交易所",
    homeTitle3: "全民的交易所",
    homeDesc3: "竭诚为不同文化、不同语言的用户提供7*24小时无间断的高品质服务",
    homeTitle4: "随时随地皆可交易",
    homeDesc4: "无论是APP还是WEB，都可以快速开启您的交易",
    homeTitle5: "什么是比特币",
    homeDesc5: "比特币是世界上最大、最著名的去中心化加密货币。 它採用区块链作為底层技术，允许用户通过点对点网络传输数据和资產，且无需任何中间人和中央银行。",
    homeTitle6: "美元可以购买数字资产吗",
    homeDesc6: "由于数字资产具有无限分割的特性，即使1美元也可以购买数字资产。",
    homeTitle7: "在 BitFuy 上交易安全吗",
    homeDesc7: "BitFuy及其团队部署了全球最专业的安全网络架构体系，并不断优化和升级安全系统，以确保用户资产和账户安全。",
    homeTitle8: "法定货币出入金是否有限制",
    homeDesc8: "BitFuy严格遵守所在国的各项法律法规，不同国家的出入金规则不同。在法律允许的国家，BitFuy 对法定货币出入金不收取任何费用且没有限制，目前C2C市场支持多种法定货币，為用户提供7*24小时的出入金服务。",
    homeTitle9: "立即开启您的数字货币之旅",
    homeDesc9: "BitFuy 为您提供最便捷的数字货币交易方式",
    digitalCurrency: "数字货币",
    qualityInformation: "高质量咨询",
    globalInvestor: "全球投资者",
    internationalCommunity: "国际社群",
    countriesCovered: "覆盖国家",
    transactionText: "请充值数字货币或购买后进行交易",
    cumulative: "累计",
    realTimeTransaction: '实时成交',
    balance: "余额",
    totalMargin: "总保证金",
    transferQuantityTips: "划转数量需大于0",
    notCertified: "未认证",
    certified: "已认证",
    underCertification: "认证中",
    digitalCurrencyTransactions: "数字货币交易",
    setCapitalPsw: "设置资金交易密码",
    authenticationTips: "请进行初级认证",
    than: "数值需大于0"
  }
}